import { RowSelection } from '~/shared/hooks/useRowSelection';

import { RowSelectCheckbox } from './RowSelectCheckbox';

interface BulkSelectAllCheckboxProps {
    selection?: RowSelection;
}

export function BulkSelectAllCheckbox({ selection }: BulkSelectAllCheckboxProps) {
    if (!selection?.isSelectMode) {
        return null;
    }

    return (
        <RowSelectCheckbox
            checked={selection.allSelected}
            onCheckedChange={selection.toggleAll}
            data-testid="bulk-select-all"
        />
    );
}
